import { useMemo } from "react"
import useFreeTrial from "./useFreeTrial"
import useUserLimits from "./useUserLimits"

export function useProgressFreeTrialsDays() {
  const { left, total } = useFreeTrial() || {}
  return useMemo(() => calculateProgressDaysLeft(left, total), [left, total])
}

export function useProgressFiles() {
  const { filesUsage, filesLimit } = useUserLimits() || {}
  return useMemo(
    () => calculateProgress(filesUsage, filesLimit),
    [filesUsage, filesLimit],
  )
}

export function useProgressQuestionnaires() {
  const { questionnairesLimit, questionnairesUsage } = useUserLimits() || {}

  return useMemo(
    () => calculateProgress(questionnairesUsage, questionnairesLimit),
    [questionnairesUsage, questionnairesLimit],
  )
}

// Progress bar fills up as resources are consumed (usage/limit)
export function calculateProgress(current?: number, total?: number): number {
  if (current == null || total == null || total === 0) return -1
  return (current / total) * 100
}

// Progress bar fills up as days pass (daysUsed/total)
function calculateProgressDaysLeft(
  currentLeft?: number,
  total?: number,
): number {
  if (currentLeft == null || total == null || total === 0) return -1
  const daysUsed = total - currentLeft
  return (daysUsed / total) * 100
}
